import { render, staticRenderFns } from "./RoiColumnar.vue?vue&type=template&id=9cdedeb8&"
import script from "./RoiColumnar.vue?vue&type=script&lang=js&"
export * from "./RoiColumnar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports